module.exports = __webpack_public_path__ + "img/treppengelaender22.e2665162.jpg";